import React, { useContext, useMemo } from 'react';
import { Button, ButtonGroup } from 'components/ui/button';
import { DensityMapControlsEventType } from '../../use-density-map-controls/event-type';
import { IconPlay, IconPause, IconChanges } from 'components/ui/icons';
import { DensityMapControlsContext } from '../context';
import { space } from 'helpers/style'
import styled from 'styled';


const speedOptions = [1, 2, 5, 10, 15];


const StyledButton = styled(Button)`
 
  &:first-child {
    margin-right: ${space(2)};
  }
  
  &:last-child {
    margin-left: ${space(2)};
  }
`

const getSpeedButtons = (currentSpeed: number, handler: (value: number) => void) => {
  return speedOptions.map(value => (
    <Button
      key={`speed_${value}`}
      variant="subtle"
      isDisabled={currentSpeed === value}
      data-speed={value}
      onClick={() => handler(value)}
        >
      {value}
    </Button>
    ));
}

export const PlaybackControls: React.FC = props => {
  const context = useContext(DensityMapControlsContext)
  if (!context) throw new Error("ControlPanelContext required");

  const {playbackSpeed, isPlaying, isRepeating, eventHandler } = context;
  
  const dispatch = (e: CustomEvent) => {
    eventHandler && eventHandler(e);
  }

  const changeSpeed = (newSpeed: number) => {
    dispatch(new CustomEvent(DensityMapControlsEventType.SET_PLAYBACK_SPEED, { detail: { value: newSpeed } }));
  };

  const speedButtons = speedOptions.map(value => (
    <Button
      key={`speed_${value}`}
      variant="subtle"
      isDisabled={playbackSpeed === value}
      data-speed={value}
      onClick={() => changeSpeed(value)}
        >
      {value}
    </Button>
    ));
  
  return (  
    <ButtonGroup>
      <StyledButton
        key="btn_toggle_play"
        isIcon={true}
        appearance={isPlaying ? 'primary' : 'secondary'}
        isSmall={true}
        onClick={() => dispatch(new CustomEvent(DensityMapControlsEventType.TOGGLE_PLAYING))}
      >
        {isPlaying ? <IconPause size="small" /> : <IconPlay size="small" />}
      </StyledButton>
      
      <ButtonGroup>{speedButtons}</ButtonGroup>

      <StyledButton
        key="btn_toggle_loop"
        appearance={isRepeating ? 'primary' : 'secondary'}
        isIcon={true}
        isSmall={true}
        onClick={() => dispatch(new CustomEvent(DensityMapControlsEventType.TOGGLE_PLAYBACK_REPEAT))}
      >
        <IconChanges size="small" />
      </StyledButton>
    </ButtonGroup>
  )
}